import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import DsTable from "@sazka/design-system/src/table/ds-table.vue";
import DsTableRow from "@sazka/design-system/src/table-row/ds-table-row.vue";
import DsTableCell from "@sazka/design-system/src/table-cell/ds-table-cell.vue";
import { TicketCheckResultsAddon } from "@/lotteries/model/ticket-check/ticket-check";
import { StringUtils } from "@sazka/utils/string-utils";

const EMPTY_CELL_STRING = "–––";


export default /*@__PURE__*/_defineComponent({
  __name: 'pp-ticket-check-results-addon-table',
  props: {
    results: {}
  },
  setup(__props: any) {



const formatAmount = (amount: number) => {
    if (amount) {
        return StringUtils.formatCurrency(amount);
    }

    return EMPTY_CELL_STRING;
};

const formatCount = (count: number) => {
    return count || EMPTY_CELL_STRING;
};

const formatMatchingNumbers = (matchingNumbers: number[]) => {
    return matchingNumbers?.join(", ") || EMPTY_CELL_STRING;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DsTable, {
    "is-scrollable": true,
    "is-responsive": true
  }, {
    default: _withCtx(() => [
      _createVNode(DsTableRow, null, {
        default: _withCtx(() => [
          _createVNode(DsTableCell, { type: "th" }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode("Uhodnutá čísla")
            ])),
            _: 1,
            __: [0]
          }),
          _createVNode(DsTableCell, { type: "th" }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode("Počet")
            ])),
            _: 1,
            __: [1]
          }),
          _createVNode(DsTableCell, { type: "th" }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode("Výhra")
            ])),
            _: 1,
            __: [2]
          }),
          _createVNode(DsTableCell, { type: "th" }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode("Počet výherců")
            ])),
            _: 1,
            __: [3]
          })
        ]),
        _: 1
      }),
      _createVNode(DsTableRow, null, {
        default: _withCtx(() => [
          _createVNode(DsTableCell, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(formatMatchingNumbers(_ctx.results.matchingNumbers)), 1)
            ]),
            _: 1
          }),
          _createVNode(DsTableCell, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(formatCount(_ctx.results.matchingNumbers?.length)), 1)
            ]),
            _: 1
          }),
          _createVNode(DsTableCell, null, {
            default: _withCtx(() => [
              _createElementVNode("span", {
                innerHTML: formatAmount(_ctx.results.winAmount)
              }, null, 8, _hoisted_1)
            ]),
            _: 1
          }),
          _createVNode(DsTableCell, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(formatCount(_ctx.results.winnersCount)), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})